import { render } from "./WarningDialog.vue?vue&type=template&id=336602a6&scoped=true"
import script from "./WarningDialog.vue?vue&type=script&lang=js"
export * from "./WarningDialog.vue?vue&type=script&lang=js"

import "./WarningDialog.vue?vue&type=style&index=0&id=336602a6&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336602a6"]])

export default __exports__